<template>
    <Dialog :dialog="dlg">
        <template v-slot:content>
            <v-card-text class="pa-4">
                <FormRow label="Handtekening">
                    <span v-if="!model.isSigned">Niet getekend</span>            
                    <TextField v-else disabled v-model='model.signed_by'></TextField>
                </FormRow>
                <FormRow v-if="model.isSigned&&model.signature" label="">
                    <img :src="`data:image/jpg;base64,${model.signature}`" style="width:50%;"/>
                </FormRow>
            </v-card-text>
        </template>
    </Dialog>
</template>



<script setup>
    import useModel from '@/features/workorders/workorder/model/appointmentedit'
    import FormRow from '@controls/forms/FormRow'
    import Dialog from '@shared/ui/dialogs/ActionDialog'
    import { ref, computed } from 'vue'
    import clsDialog from '@cls/clsDialog'
    import TextField from '@controls/input/TextField'
    const form = ref(null);

    let model = useModel();
    let dlg = ref(
        new clsDialog("workorder_signature", "Handtekening", model, [form], {
            showNote: false,
            showAttachment: false,
            icon: 'signature',
            noSubTitle: true,
            save: null,
            cancel: 'Sluit'
        } )).value;

</script>
